import { type SheetGeometryCategory, sheetGeometryCategoryExposedOnUIToViewType } from "./sheetGeometryCategory";
import type { SheetGeometryCategoryUIDescriptor } from "./sheetGeometryCategoryUIDescriptor";
import { sheetGeometryCategoryUIDescriptorMap } from "./sheetGeometryCategoryUIDescriptor";
import type { ViewportViewType } from "./viewportTypes";

const cache: { [key in SheetGeometryCategoryUIDescriptor["type"]]?: { [key in SheetGeometryCategory]?: true } } = {};

export function filterSheetSubCategoriesByType(type: SheetGeometryCategoryUIDescriptor["type"]): {
  [key in SheetGeometryCategory]?: true;
} {
  // Check if the result for this type is already cached
  if (cache[type]) {
    return cache[type];
  }

  const filteredSubCategories: { [key in SheetGeometryCategory]?: true } = {};

  for (const key in sheetGeometryCategoryUIDescriptorMap) {
    const categoryType = key as SheetGeometryCategory;
    const category = sheetGeometryCategoryUIDescriptorMap[categoryType];

    if (category && category.type === type) {
      filteredSubCategories[categoryType] = true;
    }
  }

  // Cache the result for future lookups
  cache[type] = filteredSubCategories;

  return filteredSubCategories;
}

export function isViewTemplateUICategoryForViewType(
  category: SheetGeometryCategory,
  viewType: ViewportViewType,
): boolean {
  return sheetGeometryCategoryExposedOnUIToViewType[category].includes(viewType);
}

export function isElevationViewTemplateUICategory(category: SheetGeometryCategory): boolean {
  return isViewTemplateUICategoryForViewType(category, "ELEVATION_VIEW");
}

export function viewTemplateUICategoriesForViewType(viewType: ViewportViewType): SheetGeometryCategory[] {
  return Object.keys(sheetGeometryCategoryExposedOnUIToViewType).filter((category) =>
    isViewTemplateUICategoryForViewType(category as SheetGeometryCategory, viewType),
  ) as SheetGeometryCategory[];
}
